export const en = {
  AddToBasket: 'Add To Basket',
  ConfigureYourPack: 'Configure Your Pack',
  nif: 'NIF',
  account: 'Account',
  pricingRedSentence: `* For this product, only one Edition can be selected and purchased (this doesn't have effect on the licence
  quantity).`,
};
